import React from 'react'

function Header() {
  return <h2 className='header'>Balance Bot 💰</h2>;
}

export default Header